import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AUTHENTICATED } from '../../oidc/auth.interceptor';
import { HomescreenSettings } from './settings.models';

declare const BUILD_NUMBER: string;

const API_SETTING = `${environment.apiUrl}/settings/v1/settings`;

// Same list as in the backend configuration `validKeys`.
export type SettingKey = 'homescreen';

export interface Setting<T> {
  key: SettingKey;
  version: number;
  value: T;
}

@Injectable({ providedIn: 'root' })
export class SettingsService {
  private readonly http = inject(HttpClient);

  uploadHomescreen(homescreen: HomescreenSettings): Observable<void> {
    return this.uploadSetting<HomescreenSettings>('homescreen', homescreen);
  }

  private uploadSetting<T>(key: SettingKey, setting: T): Observable<void> {
    return this.http.post<void>(`${API_SETTING}/${key}`, setting, {
      context: AUTHENTICATED,
      params: { version: BUILD_NUMBER },
    });
  }

  /** Requests the setting for `key` from the backend, for the current app version. */
  fetchSetting<T>(key: SettingKey): Observable<Setting<T>> {
    return this.http.get<Setting<T>>(`${API_SETTING}/${key}`, {
      context: AUTHENTICATED,
      params: { version: BUILD_NUMBER },
    });
  }
}
